import { createFileRoute } from "@tanstack/react-router";
import { ChatGptLandingPage, CHATGPT_FAQS } from "@/components/pages/ChatGptLandingPage";

const URL = "https://kentro.com.br/chatgpt";
const TITLE = "Atendimento com IA e CRM integrado | Kentro";
const DESC =
  "A Kentro reúne atendimento omnichannel, CRM e assistentes de IA em uma plataforma com WhatsApp API Oficial. Solicite uma demonstração.";

export const Route = createFileRoute("/chatgpt")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: "https://kentro.com.br/og-image.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://kentro.com.br/og-image.png" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Kentro",
            legalName: "Barbalho Solutions Ltda.",
            url: "https://kentro.com.br",
            logo: "https://kentro.com.br/og-image.png",
            sameAs: [
              "https://www.linkedin.com/company/kentro-sistemas",
              "https://www.instagram.com/kentrosistemas",
              "https://www.youtube.com/@kentrosistemas",
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Kentro",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web",
            url: URL,
            description:
              "Plataforma de atendimento omnichannel com CRM integrado e assistentes de inteligência artificial.",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: TITLE,
            description: DESC,
            url: URL,
            inLanguage: "pt-BR",
            isPartOf: { "@type": "WebSite", name: "Kentro", url: "https://kentro.com.br" },
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: CHATGPT_FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
        ]),
      },
    ],
  }),
  component: ChatGptLandingPage,
});
